import GA4Provider from './GA4Provider'
import CartAnalytics from './CartAnalytics'
import ProductAnalytics from './ProductAnalytics'
import ContentAnalytics from './ContentAnalytics'

/**
 * @class BrandCoAnalytics
 * @description Main analytics orchestrator that initializes and connects all analytics components
 */
class BrandCoAnalytics {
  constructor() {
    this.ga4Provider = new GA4Provider()
    this.cartAnalytics = new CartAnalytics(this.ga4Provider)
    this.productAnalytics = new ProductAnalytics(this.ga4Provider)
    this.contentAnalytics = new ContentAnalytics(this.ga4Provider)
  }
}

export default BrandCoAnalytics

// Initialize analytics
const analytics = new BrandCoAnalytics()
